import { useTheme } from "@material-ui/core"
import { Check, Eye, EyeOff, Square } from "react-feather"

export const isGanttRoute = (pathname: string) => pathname.includes("gantt")
export const isBasicRoute = (pathname: string) => pathname.includes("basic")
export const isTasksRoute = (pathname: string) => pathname.includes("tasks")
export const isKanbanRoute = (pathname: string) => pathname.includes("kanban")
export const isTodoListRoute = (pathname: string) => pathname.includes("todos")
export const isCalendarRoute = (pathname: string) => pathname.includes("calendar")
export const isDashboardRoute = (pathname: string) => pathname.includes("dashboard")
export const isReportedHoursRoute = (pathname: string) => pathname.includes("reported-hours")

const tabsOrder = ["basic", "gantt", "tasks", "todos", "calendar", "kanban", "reported-hours", "dashboard"]

export const getActiveTabIndex = (pathname: string, canViewReportedHoursTab = true) => {
  const index = tabsOrder.findIndex((tab) => pathname.includes(tab))
  if (index === -1) return 0

  const reportedHoursIndex = tabsOrder.indexOf("reported-hours")
  if (!canViewReportedHoursTab && index === reportedHoursIndex) return false
  if (!canViewReportedHoursTab && index > reportedHoursIndex) return index - 1

  return index
}

export const EyeIcon = ({ isShown, size = 20 }: { isShown: boolean; size?: number }) => {
  if (isShown) return <EyeOff size={size} />
  else return <Eye size={size} />
}

export const CheckIcon = ({ isChecked }: { isChecked: boolean }) => {
  const theme = useTheme()
  const style = { background: theme.palette.primary.main, stroke: theme.palette.common.white, borderRadius: 3 }

  if (isChecked) {
    return <Check style={style} size={16} />
  } else {
    return <Square size={18} />
  }
}
